import React from 'react';
import {
  sanitizeNoteHtml,
  isLikelyRichHtml,
  normalizeNoteContentForDisplay,
} from '../core/utils/noteRichText';
import './RichNoteEditor.css';

/**
 * Renders a note body: sanitized HTML for rich notes, plain text for legacy entries.
 */
const NoteRichContent = ({ content }) => {
  const raw = content ?? '';
  const normalized = normalizeNoteContentForDisplay(raw);
  if (isLikelyRichHtml(normalized)) {
    return (
      <div
        className="note-rich-content mt-2 text-sm text-gray-800 leading-relaxed"
        dangerouslySetInnerHTML={{ __html: sanitizeNoteHtml(normalized) }}
      />
    );
  }
  return (
    <p className="mt-2 whitespace-pre-wrap text-sm text-gray-800 leading-relaxed">
      {normalized}
    </p>
  );
};

export default NoteRichContent;
